import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { WA_WINDOW } from '@ng-web-apis/common';
import { RouteUtilityService } from '@rma/dashboard/generic/util/router-utils';
import { debounceTime, map, Observable } from 'rxjs';

@Component({
  selector: 'rma-skip-to-content',
  imports: [AsyncPipe],
  templateUrl: './skip-to-content.component.html',
  styleUrls: ['./skip-to-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkipToContentComponent {
  protected readonly url$: Observable<string>;

  public constructor(
    @Inject(WA_WINDOW) private readonly window: Window,
    routerUtil: RouteUtilityService,
  ) {
    this.url$ = routerUtil.endEvents.pipe(
      //The end event fires before the route actually changes. Can be removed With UI router
      debounceTime(100),
      map(() => `${this.getPath()}#rma-main-content`),
    );
  }

  private getPath(): string {
    //When UI router it removed: /dashboard${router.url}
    return this.window.location.pathname;
  }
}
